import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouteStorage } from './storage/route.storage';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { REGISTRY_STORAGE } from './registry-storage.token';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { PaginationComponent } from './components/pagination/pagination.component';
import { RegistryService } from './service/registry.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatTooltipModule,
    OverlayModule,
  ],
  declarations: [PaginationComponent],
  exports: [
    PaginationComponent
  ],
  providers: [
    {
      provide: REGISTRY_STORAGE,
      useClass: RouteStorage,
      deps: [ActivatedRoute, Router],
    },
    RegistryService,
  ],
})
export class RegistryModule {}
